export const emptyTrashCopy = {
  header: '',
  description: '',
  confirmBtnText: '',
  successToast: '',
};
